import { Box, Button } from '@material-ui/core'
import { useStyles } from './styles'
import PDF from '../../svgs/pdf'

function FilledButton(props) {
  const classes = useStyles()
  const {
    primary,
    pdftab,
    pdftabselected,
    enlightentab,
    upload,
    tertiary,
  } = props

  return (
    <Button
      {...props}
      className={
        classes.root +
        (primary ? ' ' + classes.primary : '') +
        (pdftab ? ' ' + classes.pdftab : '') +
        (pdftabselected ? ' ' + classes.pdftabselected : '') +
        (enlightentab ? ' ' + classes.enlightentab : '') +
        (upload ? ' ' + classes.upload : '') +
        (tertiary ? ' ' + classes.tertiary : '')
      }
      disableRipple
      disableFocusRipple
      style={{
        height: props.height || 'auto',
        width: props.width || 'auto',
        textTransform: 'none',
      }}
    >
      {pdftab ? (
        <Box
          style={{
            height: '17px',
            width: '17px',
            // border: '2px solid red',
          }}
        >
          <PDF></PDF>
        </Box>
      ) : null}
      <>{props.label}</>
    </Button>
  )
}

export default FilledButton
